// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"74b6c9a6","44":"2f88fd8c","152":"ffb0e144","220":"783b0ad8","280":"02f7db7e","284":"c72bada3","324":"830a4ee2","352":"af2bd54a","360":"67bd01d6","456":"2d0f6ca7","576":"66507ac8","580":"44ec608a","600":"d96e3078","628":"057397b8","684":"29b9dd3d","764":"1ce1fbfb"}[chunkId] + ".chunk.js";
};